import React from 'react';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const FindingsContextualSlideOver = withErrorBoundary(
  React.lazy(
    () =>
      import('../../../micro-frontends/components/FindingsContextualSlideOverView'),
  ),
);

interface FindingContextualViewSlideOverContentProps {
  data: {
    detectionId?: string;
    findingId?: string;
    message?: string;
    rowData?: unknown;
  };
  close?: () => void;
}

export const FindingContextualViewSlideOverContent = (
  props: FindingContextualViewSlideOverContentProps,
) => {
  return (
    <FindingsContextualSlideOver
      {...props.data}
      isContextualView={false}
      onClose={props.close}
    />
  );
};
